import React from 'react';
import './VisionMission.css';

const VisionMission = () => {
  // Inline SVG components
  const TargetIcon = () => (
    <svg viewBox="0 0 24 24" width="40" height="40" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg>
  );

  const EyeIcon = () => (
    <svg viewBox="0 0 24 24" width="40" height="40" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
  );

  return (
    <div className="ti-root-container">
      <div className="ti-main">
        {/* Hero Header */}
<div className="ti-hero">
          <div className="ti-badge">Our Mission</div>
      &nbsp;
<div className="ti-hero-title">
  Building Intelligent Systems <br /> for a&nbsp;
  <div className="ti-gradient-text">Smarter World</div>
</div>
          <div className="ti-hero-sub">
            Our mission is to nurture talent that drives progress, strengthens communities, and shapes the future of technology.
          </div>
        </div>

        {/* Mission & Vision Grid */}
        <div className="ti-grid">
          <div className="ti-grid-divider"></div>

          {/* Mission */}
          <div className="ti-card ti-card-right">
            <div className="ti-card-heading">
              <div className="ti-icon-wrapper ti-blue-bg">
                <TargetIcon />
              </div>
              <div className="ti-card-title">Our Mission</div>
            </div>
            <div className="ti-card-text">
              Thakur Institute of Management Studies, Career Development & Research will become a premier institute renowned internationally for providing education in software application to graduates from various disciplines.
            </div>
          </div>

          {/* Vision */}
          <div className="ti-card ti-card-left">
            <div className="ti-card-heading">
              <div className="ti-icon-wrapper ti-orange-bg">
                <EyeIcon />
              </div>
              <div className="ti-card-title">Our Vision</div>
            </div>
            <div className="ti-card-text">
              To achieve excellence in providing software education so that students can grasp existing as well as emerging technologies and to inculcate leadership and managerial qualities in them so that they can deliver results in the organization they join.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;